document.addEventListener('DOMContentLoaded', function () {
  const productForms = document.querySelectorAll('form[data-product-form]');

  productForms.forEach(form => {
    form.addEventListener('submit', async function (e) {
      const addonSelect = form.querySelector('#addon-select');


      const ninjaWorksInput = form.querySelector('#athlete-ninjaworks-id');
      const ninjaWorksRegex = /^\d{6}$/;

      if (ninjaWorksInput && !ninjaWorksRegex.test(ninjaWorksInput.value)) {
        e.preventDefault();
        alert('NinjaWorks ID must be exactly 6 digits.');
        ninjaWorksInput.focus();
        return;
      }











      // No add-on selected → let Shopify handle normally
      if (!addonSelect || !addonSelect.value) {
        return;
      }

      e.preventDefault();

      const formData = new FormData(form);
      const mainVariantId = formData.get('id');
      const quantity = formData.get('quantity') || 1;
      const addonVariantId = addonSelect.value;

      // Collect line item properties automatically
      const properties = {};
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) {
          const propName = key.replace('properties[', '').replace(']', '');
          properties[propName] = value;
        }
      }

      const items = [
        {
          id: mainVariantId,
          quantity: quantity,
          properties: properties
        },
        {
          id: addonVariantId,
          quantity: 1,
          properties: {
            ...properties,
            "Add-On For": form.dataset.productTitle || 'Main Product'
          }
        }
      ];

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        window.location.href = '/cart';
      } catch (err) {
        console.error('Add-on cart error', err);
      }
    });
  });
});
